import { styled, CarouselSlide, LinearProgress } from '@hermes/web-components'

export const StyledSplideSlide = styled(CarouselSlide)`
  transition: opacity 0.5s ease-in-out;

  &.splide__slide.is-visible {
    opacity: 1;

    & > div {
      transform: scale(1);
      transition: transform 0.5s ease-in-out;
    }
  }

  &:not(.is-visible) {
    opacity: 0;

    & > div {
      transform: scale(0.8);
    }
  }
`

export const StyledLinnearProgress = styled(LinearProgress)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  bottom: '90px',
  height: '2px',
  [`&.MuiLinearProgress-colorPrimary`]: {
    backgroundColor: '#D5DEF9',

  },
  [`&.MuiLinearProgress-bar`]: {
    borderRadius: 5,
    backgroundColor: 'red',
  },
  [theme.breakpoints.down('md')]: {
    bottom: '100px'
  }
}));